<template>
  <b-container v-if="type && models" fluid>
    <page-title icon="fas fa-tachometer-alt">
      <translate>OCR Control</translate>
    </page-title>

    <api-list type="ocr-control" :model="models.ocrControl" :quick-filters="quickFiltersSetup.ocrControl" />

  </b-container>
</template>

<script>
import ApiList from '@/components/ApiLists/ApiList'

export default {
  name: 'OcrList',
  title() {
    return this.$gettext('OCR Control')
  },
  components: {
    ApiList
  },
  props: {
    type: {
      type: String,
      default: 'shippings'
    }
  }
}
</script>
